<div class="tw-block tw-bg-gray-100">
  <!-- Regimen Hero-->
  <section class="tw-bg-grid-layout tw-bg-repeat-x tw-bg-top" *ngIf="is2499Upsell" [ngClass]="backgroundColor" (click)="clickOnRegimenImage()">
    <div class="tw-pb-8 tw-mb-2">
      <img class="tw-mb-5 tw-block" *ngIf="regimen?.regimenCoverImage" [src]="regimen?.regimenCoverImage" appPinchZoom="appPinchZoom" />
      <h3 [class]="{'tw-font-lexend': acqRebranding2025, 'tw-font-body': !acqRebranding2025}" class="tw-font-bold tw-text-center tw-text-500 tw-text-gray-900 tw-mb-4" *ngIf="isAcqCopyChangesExpActive && appConfig.Shared.Regimen.Class.FACE === regimen.class" i18n="@@skinRoutineReadyV2">
        {{patientName}}, your personalised skin <br />routine is ready
      </h3>
      <h3 [class]="{'tw-font-lexend': acqRebranding2025, 'tw-font-body': !acqRebranding2025}" class="tw-font-bold tw-text-center tw-text-500 tw-text-gray-900 tw-mb-4" *ngIf="!isAcqCopyChangesExpActive && appConfig.Shared.Regimen.Class.FACE === regimen.class" i18n="@@skinKitReady">
        {{patientName}}, your skin <br />treatment kit is ready!
      </h3>
      <h3 [class]="{'tw-font-lexend': acqRebranding2025, 'tw-font-body': !acqRebranding2025}" class="tw-text-center tw-font-bold tw-text-500 tw-text-gray-900 tw-mb-4" *ngIf="isAcqCopyChangesExpActive && appConfig.Shared.Regimen.Class.HAIR === regimen.class" i18n="@@hairRoutineReadyV2">
        {{patientName}}, your personalised hair <br />routine is ready
      </h3>
      <h3 [class]="{'tw-font-lexend': acqRebranding2025, 'tw-font-body': !acqRebranding2025}" class="tw-text-center tw-font-bold tw-text-500 tw-text-gray-900 tw-mb-4" *ngIf="!isAcqCopyChangesExpActive && appConfig.Shared.Regimen.Class.HAIR === regimen.class" i18n="@@hairKitReady">
        {{patientName}}, your hair <br />treatment kit is ready!
      </h3>
      <!-- Regimen offer banner -->
      <app-regimen-offer-product-banner *ngIf="((newRegimenPricingExperiment && !regimen?.orderPlaced) || regimen?.extraProducts?.length)" (click)="$event?.stopPropagation(); regimenOfferProductEvent();" class="tw-mx-4 tw-mb-4">
        <app-regimen-offer-tag><span i18n="@@limitedTimeOfferPouch">Limited time offer</span></app-regimen-offer-tag>
        <regimen-offer-product-title><span i18n="@@freePouch">+ Free Pouch</span></regimen-offer-product-title>
        <regimen-offer-product-caption><span i18n="@@withYourPurchase">with your treatment kit purchase</span></regimen-offer-product-caption>
      </app-regimen-offer-product-banner>
      <!-- Regimen offer banner -->
      <!-- Regimen Tags -->
      <ul class="tw-px-4 tw-flex tw-flex-row tw-justify-between tw-items-start tw-gap-1" *ngIf="newRegimenIconsExperiment && doesAllTagsContainRebrandedImages">
        <li class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-gap-1.5" *ngFor="let item of regimen.regimenTag">
          <div class="tw-relative tw-z-[1] gradient-border after:tw-content-[''] after:tw-absolute after:tw-w-full after:tw-h-full after:tw-top-1/2 after:tw-left-1/2 after:tw-rounded-full after:tw-p-[21.5px] after:tw-z-[-1]  after:[background-image:linear-gradient(to_right,var(--from-color)_10%,var(--to-color)_100%)] after:tw-animate-rotate"
               [style.--from-color]="getFromColor()"
               [style.--to-color]="getToColor()">
            <img class="tw-h-10 tw-w-10" [src]="item.rebrandedImageV2" />
          </div>
          <p [class]="{'tw-font-lexend': acqRebranding2025, 'tw-font-body': !acqRebranding2025}" class="tw-text-200 tw-text-gray-900 tw-text-center tw-break-words tw-leading-3">
            {{ item.title }}
          </p>
        </li>
      </ul>
      <ul class="tw-px-4 tw-flex tw-flex-row tw-justify-between tw-items-start tw-gap-1" *ngIf="!newRegimenIconsExperiment || (newRegimenIconsExperiment && !doesAllTagsContainRebrandedImages)">
        <li class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-gap-1.5" *ngFor="let item of regimen.regimenTag">
          <img class="tw-h-10 tw-w-10" [src]="item.rebrandedImage" />
          <p [class]="{'tw-font-lexend': acqRebranding2025, 'tw-font-body': !acqRebranding2025}" class="tw-text-200 tw-text-gray-900 tw-text-center tw-break-words tw-leading-3">
            {{ item.title }}
          </p>
        </li>
      </ul>
    </div>
  </section>
  <section class="tw-bg-grid-layout tw-bg-repeat-x tw-bg-top" *ngIf="!is2499Upsell" [ngClass]="{'tw-bg-orange-100':  appConfig.Shared.Regimen.Class.HAIR === regimen.class, 'tw-bg-purple-100':  appConfig.Shared.Regimen.Class.FACE === regimen.class }" (click)="clickOnRegimenImage()">
    <div class="tw-pb-8 tw-mb-2">
      <img class="tw-block tw-mb-5" *ngIf="regimen?.regimenCoverImage" [src]="regimen?.regimenCoverImage" appPinchZoom="appPinchZoom" />
      <h3 class="tw-font-body tw-font-bold tw-text-center tw-text-500 tw-text-gray-900 tw-mb-4" *ngIf="isAcqCopyChangesExpActive && appConfig.Shared.Regimen.Class.FACE === regimen.class" i18n="@@skinRoutineReadyV2">
        {{patientName}}, your personalised skin <br />routine is ready
      </h3>
      <h3 class="tw-font-body tw-font-bold tw-text-center tw-text-500 tw-text-gray-900 tw-mb-4" *ngIf="!isAcqCopyChangesExpActive && appConfig.Shared.Regimen.Class.FACE === regimen.class" i18n="@@skinKitReady">
        {{patientName}}, your skin <br />treatment kit is ready!
      </h3>
      <h3 class="tw-font-body tw-font-bold tw-text-center tw-text-500 tw-text-gray-900 tw-mb-4" *ngIf="isAcqCopyChangesExpActive && appConfig.Shared.Regimen.Class.HAIR === regimen.class" i18n="@@hairRoutineReadyV2">
        {{patientName}}, your personalised hair <br />routine is ready
      </h3>
      <h3 class="tw-font-body tw-font-bold tw-text-center tw-text-500 tw-text-gray-900 tw-mb-4" *ngIf="!isAcqCopyChangesExpActive && appConfig.Shared.Regimen.Class.HAIR === regimen.class" i18n="@@hairKitReady">
        {{patientName}}, your hair <br />treatment kit is ready!
      </h3>
      <!-- Regimen offer banner -->
      <app-regimen-offer-product-banner *ngIf="((newRegimenPricingExperiment && !regimen?.orderPlaced) || regimen?.extraProducts?.length)" (click)="$event?.stopPropagation(); regimenOfferProductEvent();" class="tw-mx-4 tw-mb-4">
        <app-regimen-offer-tag><span i18n="@@limitedTimeOfferPouch">Limited time offer</span></app-regimen-offer-tag>
        <regimen-offer-product-title><span i18n="@@freePouch">+ Free Pouch</span></regimen-offer-product-title>
        <regimen-offer-product-caption><span i18n="@@withYourPurchase">with your treatment kit purchase</span></regimen-offer-product-caption>
      </app-regimen-offer-product-banner>
      <!-- Regimen offer banner -->
      <ul class="tw-px-4 tw-flex tw-flex-row tw-justify-between tw-items-start tw-gap-1" *ngIf="regimen.regimenTag && regimen.regimenTag[0]?.rebrandedImage">
        <li class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-gap-1.5" *ngFor="let item of regimen.regimenTag">
          <img class="tw-h-10 tw-w-10" [src]="item.rebrandedImage" />
          <p class="tw-font-body tw-text-200 tw-text-gray-900 tw-text-center tw-break-words">
            {{ item.title }}
          </p>
        </li>
      </ul>
    </div>
  </section>
  <ng-container *ngIf="!regimenRehaulV1Experiment || ( regimenRehaulV1Experiment && !removeVariants)">
    <choose-plan
      [class]="choosePlanClasses"
      *ngIf="is2499Upsell && !regimen?.orderPlaced && !isKeyboardVisible"
      style="background: rgba(255, 255, 255, 1)"
      [acqRebranding2025]="acqRebranding2025"
      [regimen]="regimen"
      [instructionsVisibilityExp]="instructionVisibilityImprovementExperiment?.enable"
      [isAcqCopyChangesExpActive]="isAcqCopyChangesExpActive"
      (onSelectPlan)="changeRegimenKitInfo($event)"
      (onReadMore)="readMoreAboutPlans()"
      (hideVariants)="is2499Upsell = false">
    </choose-plan>
  </ng-container>
  <!-- Kit items-->
  <product-list *ngIf="regimen.morning[0]?.product?.title" [acqRebranding2025]="acqRebranding2025" [regimenRehaulV3Experiment]="regimenRehaulV3Experiment" [products]="products" [showSingleCtaProducts]="singleCtaProducts" [isAcqCopyChangesExpActive]="isAcqCopyChangesExpActive" [showViewMore]="instructionVisibilityImprovementExperiment?.enable" (onClick)="clickOnProductImage()" (onReadMoreClick)="readMoreAboutProducts()" (onInstructionClick)="seeInstructions()"></product-list>
  <!-- Doctor card-->
  @if(allocatedDoctor) {
    <section class="tw-my-6">
      <app-regimen-doctor-details-card
        [regimen]="regimen"
        [allocatedDoctor]="allocatedDoctor"
        [user]="user"
        [reportPageView]="true"
        (readMoreClick)="readMoreAboutDoctor()">
      </app-regimen-doctor-details-card>
    </section>
  }
  @if (shouldShowPendingCallBannerContainer) {
    <div [ngClass]="doctorCallBannerContainerClasses">
      <app-unpaid-user-doctor-call-banner-container
        [bannerState]="pendingCallBannerState"
        [regimen]="regimen"
        [pendingCalls]="this.unpaidUserDoctorCalls"
        viewMode="regimen"
        (callCreated)="onPendingCallCreated()">
      </app-unpaid-user-doctor-call-banner-container>
    </div>
  }
  @if (shouldShowChatBanner) {
    <div [ngClass]="chatBannerContainerClasses">
      <app-user-query-chat-banner
        [user]="user"
        [showHeader]="!pendingCallBannerExperiment || (pendingCallBannerExperimentVariantData?.newBannerUI || pendingCallState)"
        [regimen]="regimen">
      </app-user-query-chat-banner>
    </div>
  }
  <!-- Services-->
  <regimen-value-proposition-v2 [regimenUpdateTrigger]="regimenUpdateTrigger()" [user]="user" [allocatedDoctorImage]="allocatedDoctor?.get('DoctorImageThumbnail') || allocatedDoctor?.get('doctorDisplayImage') || defaultDoctorImageThumbnail" [backgroundColor]="backgroundColor" [videoCallExperiment]="videoCallExperiment" (readMoreClick)="readMoreAboutServices()"></regimen-value-proposition-v2>
  @if (showMoneyBackGuaranteeBanner) {
    <app-money-back-guarantee-banner class="tw-block tw-my-5" [pageView]="MoneyBackGuaranteePageView.REGIMEN" [regimen]="regimen"></app-money-back-guarantee-banner>
  }
  <ng-container *ngIf="regimen.class === appConfig.Shared.Regimen.Class.HAIR && user?.get('Gender') === appConfig.Shared.Gender.MALE">
    <img [class]="showMoneyBackGuaranteeBanner ? 'tw-px-5 tw-pb-5' : 'tw-p-5'" src="https://cdn.cureskin.com/app/img/whatToExpect_{{user?.get('languagePreference') === 'hi' ? 'hi' : 'en'}}.gif" />
  </ng-container>
  <testimonial-wall [regimen]="regimen" [experiments]="experiments"></testimonial-wall>
  <app-faq-section></app-faq-section>
  <div class="tw-mt-6 tw-mx-6 tw-font-body tw-text-300 tw-pb-2"
       *ngIf="!regimen.orderPlaced"
       [style.marginBottom.px]="startAgainMarginBottomPx"
       (click)="startAgain()">
    <div class="tw-text-gray-500" i18n="@@forgotToShare"> Forgot to share some important information? </div>
    <div class="tw-text-gray-500" i18n="@@neverLate"> It's never too late! Simply re-answer the questions. </div>
    <hr class="tw-my-1" />
    <div class="tw-font-bold tw-text-gray-700" i18n="@@changeAnswers"> + Click Here to Change the answers </div>
    <div *ngIf="showRefundPolicyOption">
      <refund-policy></refund-policy>
    </div>
  </div>
</div>
